(function() {
  'use strict';

  angular
    .module('traineeWebApp.services')
    .factory('trackingService', trackingService);

  trackingService.$inject = ['gac'];

  function trackingService(gac) {
    var service = null;
    var kissMetricsDefaults = {};

    function create() {
      var lastEvent = {
        category: null,
        action: null,
        time: 0
      };

      function trackEvent(category, action) {
        var event = {
          category: category,
          action: action,
          time: new Date().time
        };

        if (ignoreEvent(event)) return;
        lastEvent = event;
        ga('send', 'event', event.category, event.action, "Trainee");
      }

      function trackPageView(pageName) {
        ga('send', 'pageview', pageName);
      }

      function ignoreEvent(event) {
        return typeof ga === 'undefined'
          || (
            lastEvent
            && lastEvent.time > event.time - 1000
            && lastEvent.category == event.category
            && lastEvent.action == event.action
          );
      }

      function kissMetricsEnabled() {
        return typeof _kmq != 'undefined';
      }

      function setupKissMetrics(params) {
        if (!kissMetricsEnabled()) {
          return;
        }

        _kmq.push(['identify', params.email]);

        kissMetricsDefaults["Account ID"] = params.accountId;
        kissMetricsDefaults["User ID"] = params.userId;
        kissMetricsDefaults["Company Name"] = params.accountInfo.companyName;
        kissMetricsDefaults["User Role"] = mfConfig.permissionsName;
      }

      function trackKissMetricsEvent(event, params) {
        if (!kissMetricsEnabled()) {
          return;
        }

        _kmq.push(['record', event, _.defaults(params || {}, kissMetricsDefaults)]);
      }

      return {
        trackEvent: trackEvent,
        trackPageView: trackPageView,
        setupKissMetrics: setupKissMetrics,
        trackKissMetricsEvent: trackKissMetricsEvent,
        pages: gac.pages
      };
    }

    if (!service)
      service = create();

    return service;
  }
})();
